// v-safe-html：v-html 的消毒替代。后台富文本（知识库/消息/AI 回复）统一经 DOMPurify 输出。
// 用法与 v-html 相同：<div v-safe-html="richText"></div>
import DOMPurify from 'dompurify'

const sanitize = (value) => DOMPurify.sanitize(value ?? '', {
  USE_PROFILES: { html: true }
})

export default {
  mounted(el, binding) {
    el.innerHTML = sanitize(binding.value)
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = sanitize(binding.value)
    }
  }
}
